export enum LoginType {
    GITLAB = 'gitlab_public',
    MSUITE_ACCOUNT = 'restful',
    VCS_LDAP = 'ldap',
    VIETTEL_SSO = '',
    RADIUS = 'radius',

}

export enum OtpType {
    SMS = 'SmsOtp',
    RADIUS = 'RadiusOtp',
    TOTP = 'Totp',
    EmailOtp = 'EmailOtp',
    SecurityKey = 'SecurityKey'
}

export const OTP_METHOD = [OtpType.SMS, OtpType.TOTP, OtpType.EmailOtp, OtpType.SecurityKey, OtpType.RADIUS];

export const BIOMETRIC_KEY = 'Biometric';
export const SECURITY_KEY = 'SecurityKey';

export const MSUITE_LOCAL_KEY = 'msuite_local';

export const LOGIN_TYPE_KEY = 'login_type';

export enum EnterOtpStep {
    SCAN_QR,
    ENTER_OTP
}
